import React from "react";
import "../styles/portfolio.css";
import PortfolioNavbar from "./elements/portfolionavbar";
import TestimonialsRow from "./elements/testimonialsrow";
import FaqQuestion from "./elements/faqquestion";
import { FaLocationDot } from "react-icons/fa6";
import PortfolioFooter from "./elements/portfoliofooter";
const Logo =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/logo.svg";
const HomeScreen =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/bannerfinal.svg";
const explore1image =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/img.svg";
const explore2image =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/explore2.svg";
const explore3image =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/explore3.svg";

const explore4image =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/explore4.svg";
const bottomleftone =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/statsbottomleft.svg";

const blogIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/statsicons/blog.svg";
const literatureIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/statsicons/literature.svg";
const supportIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/statsicons/support.svg";

const newsIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/statsicons/news.svg";

const offersIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/statsicons/offer.svg";
const starIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/statsicons/star.svg";
const focusIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/statsicons/focus.svg";

const CustomizeIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/statsicons/customize.svg";
const heartIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/heart.svg";
export default function Contact() {
  return (
    <div className="portfolio">
      <div className="portfoliopadding">
        <div className="portfoliohome">
          <PortfolioNavbar colortheme="blue" />
        </div>
        <div className="portfoliohomebodycontact">
          <button className="portfoliogradientbutton">Contact</button>
          <h2 className="h2headerportfolio">Say Hello </h2>
          <p>
            Get in touch <br />
            Let’s shape the future of healthcare together .
          </p>
        </div>

        <div className="portfoliocontactform">
          <form className="gradientdiv portfolioform">
            <div className="portfolioforminputdiv">
              <div className="portfolioforminputdivhalf">
                <label>First name*</label>
                <input type="text" required />
              </div>
              <div className="portfolioforminputdivhalf">
                <label>Last name*</label>
                <input type="text" required />
              </div>
            </div>
            <div className="portfolioforminputdiv">
              <div className="portfolioforminputdivhalf">
                <label>Email*</label>
                <input type="email" required />
              </div>
              <div className="portfolioforminputdivhalf">
                <label>Company*</label>
                <input type="text" required />
              </div>
            </div>
            {/* <div className="portfolioforminputdivselect">
              <label>Topic*</label>
              <select name="topic" required>
                <option value="" selected disabled>
                  Select
                </option>
                <option value="topic1">Topic 1</option>
                <option value="topic2">Topic 2</option>
                <option value="topic3">Topic 3</option>
              </select>
            </div> */}
            <div className="portfolioforminputdiv">
              <div className="portfolioforminputdivfull">
                <label>Topic*</label>
                <textarea required />
              </div>
            </div>
            <div className="portfoliocheckbox">
              <input type="checkbox" name="agree" />
              <p>I agree to the Privacy & Terms.</p>
            </div>
            <button className="portfoliogradientbutton">Submit</button>
            <div className="porfoliocontactformheader">
              <div className="portfoliocontactformheaderleft">
                <FaLocationDot />
              </div>
              <div className="portfoliocontactformheaderright">
                <h2>Office Address</h2>
                <p>580 Sector 9, Urban Estate, Gurgaon</p>
              </div>
            </div>
          </form>
        </div>

        <PortfolioFooter />
      </div>
    </div>
  );
}
